/**
 * Common variables for project page reducers
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

/* PROJECT ACTIONS
================================================================================================ */
export const FETCH = "project/FETCH";
export const FETCH_REQUEST = "project/FETCH_REQUEST";
export const FETCH_SUCCESS = "project/FETCH_SUCCESS";
export const FETCH_FAILURE = "project/FETCH_FAILURE";
export const FETCH_STATS = "project/FETCH_STATS";
export const FETCH_STATS_SUCCESS = "project/FETCH_STATS_SUCCESS";
export const FETCH_NEW_PROJECTS = "project/FETCH_NEW_PROJECTS";
export const FETCH_NEW_PROJECTS_SUCCESS = "project/FETCH_NEW_PROJECTS_SUCCESS";
export const TOGGLE_VIOLATION = "project/TOGGLE_VIOLATION";
export const TOGGLE_STATS = "project/TOGGLE_STATS";

/* ENTRY ACTIONS
================================================================================================ */
export const ENTRY_ZOOM_IN = "project/ENTRY_ZOOM_IN";
export const ENTRY_ZOOM_OUT = "project/ENTRY_ZOOM_OUT";
export const ENTRY_RESET_ZOOM = "project/ENTRY_RESET_ZOOM";

export const TOGGLE_ENTRY_DELETE = "project/TOGGLE_ENTRY_DELETE";
export const TOGGLE_ENTRY_REINSTATE = "project/TOGGLE_ENTRY_REINSTATE";

/* REVISION ACTIONS
================================================================================================ */
export const SCORE_REVISION = "project/SCORE_REVISION";
export const SCORE_REVISION_SUCCESS = "project/SCORE_REVISION_SUCCESS";
export const SCORE_REVISION_FAILURE = "project/SCORE_REVISION_FAILURE";
export const FETCH_COMMENTS = "project/FETCH_COMMENTS";
export const FETCH_COMMENTS_SUCCESS = "project/FETCH_COMMENTS_SUCCESS";
export const FETCH_COMMENTS_FAILURE = "project/FETCH_COMMENTS_FAILURE";
export const ADD_COMMENT = "project/ADD_COMMENT";
export const ADD_COMMENT_SUCCESS = "project/ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILURE = "project/ADD_COMMENT_FAILURE";
export const ADD_COMMENT_REPLY = "project/ADD_COMMENT_REPLY";
export const ADD_COMMENT_REPLY_SUCCESS = "project/ADD_COMMENT_REPLY_SUCCESS";
export const ADD_COMMENT_REPLY_FAILURE = "project/ADD_COMMENT_REPLY_FAILURE";
export const REVISION_FEEDBACK = "project/REVISION_FEEDBACK";
export const REVISION_FEEDBACK_SUCCESS = "project/REVISION_FEEDBACK_SUCCESS";
export const REVISION_FEEDBACK_FAILURE = "project/REVISION_FEEDBACK_FAILURE";
export const TOGGLE_HIDE_COMMENT = "project/TOGGLE_HIDE_COMMENT";
export const TOGGLE_IN_PLACE_COMMENTS = "project/TOGGLE_IN_PLACE_COMMENTS";
